module.exports = __webpack_public_path__ + "static/media/shaver.a42a8ebf.svg";